module.exports = __webpack_public_path__ + "static/Trimex Outdoor Media Kit 2024 Timar-4f806fef4137db4aed656f496541ff33.pdf";